module.exports = __webpack_public_path__ + "img/apparatus3.458821bd.jpg";